import { z } from "zod";

export const DEMO_LIFECYCLES = [
  "provisioning",
  "ready",
  "active",
  "draining",
  "retired",
] as const;
export const DEMO_LIFECYCLE = {
  PROVISIONING: "provisioning",
  READY: "ready",
  ACTIVE: "active",
  DRAINING: "draining",
  RETIRED: "retired",
} as const;
export const DemoLifecycleSchema = z.enum(DEMO_LIFECYCLES);
export type DemoLifecycle = z.infer<typeof DemoLifecycleSchema>;
